import { createSelector } from 'reselect'

export const getOrderForm = createSelector(
  state => state && state.vehicleParts && state.vehicleParts.detail && state.vehicleParts.detail.orderForm ? state.vehicleParts.detail.orderForm : null,
  orderForm => orderForm
)
